export default __webpack_public_path__ + "static/curtain.inspirations-645142bff5d1c3e3f153d7e99ee17230.jpg";